<template>
    <div>
        <div v-html="descriptionShown" style="display:inline-block;">
        </div >
         <div v-if="!showMore" @click="showMore = true" style="margin-top: 10px; text-decoration: underline;">Show Whole Description</div>

        

    </div>

</template>

<script>
    export default {
        props: {
            description: {
                required: true,
                type: String
            }
        },
        data() {
            return {
                showMore: false
            }
        },
        computed: {
            descriptionShown() {
                if(this.description.length > 120 && !this.showMore) {
                    return this.description.substring(0, 110) + ' ... '
                }

                return this.description
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>